import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import router from './modules/router'
import user from './modules/user'
import getters from './getters'
import goods from './modules/goods'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    router,
    user,
    goods
  },
  getters
})

export default store
